// import { useEffect, useRef } from "react"

// const cleanWordPressHTML = (html) => {
//     console.log(html)
//   let cleaned = html.replace(/<!--\s*\/?wp:[\s\S]*?-->/g, '')

//   // ❗ eliminar atributos ref="..."
//   cleaned = cleaned.replace(/\sref="[^"]*"/gi, '')

//   // Opcional: eliminar también ref sin comillas (por si acaso)
//   cleaned = cleaned.replace(/\sref=[^\s>]+/gi, '')

//   cleaned = cleaned.replace(/\s+/g, ' ')
//   cleaned = cleaned.replace(/>\s+</g, '><')

//   return cleaned.trim()
// }

// const TermsModal = ({content}) => {

//     const contentRef = useRef<HTMLDivElement>(null)

//     useEffect(() => {
//         console.log('oeeeee', content.length, contentRef.current)
//         if (content && contentRef.current) {
//             const cleanedContent = cleanWordPressHTML(content)

//             console.log('cleanedContent', cleanedContent)

//             contentRef.current.innerHTML = cleanedContent
//         }
//     }, [content])

//     return <div
//                 ref={contentRef}
//                 style={{
//                 padding: '40px',
//                 lineHeight: '1.6',
//                 }}
//             />
// }

// export default TermsModal


import DOMPurify from "dompurify"

const cleanWordPressHTML = (html) => {
  if (!html) return ""

  // Eliminar comentarios de Gutenberg
  let cleaned = html.replace(/<!--\s*\/?wp:[\s\S]*?-->/g, '')

  // Sanitizar HTML (elimina scripts, refs, etc.)
  cleaned = DOMPurify.sanitize(cleaned, {
    FORBID_ATTR: ['ref'], // evita el error que tienes
  })

  // Opcional: limpiar espacios
  cleaned = cleaned.replace(/\s+/g, ' ')
  cleaned = cleaned.replace(/>\s+</g, '><')

  return cleaned.trim()
}

const TermsModal = ({ content }) => {
  const cleanedContent = cleanWordPressHTML(content)

  return (
    <div
      dangerouslySetInnerHTML={{ __html: cleanedContent }}
      style={{
        padding: '40px',
        lineHeight: '1.6',
      }}
    />
  )
}

export default TermsModal